import Carousel from './carousel.vue';
import Slide from './slide.vue';

const install = (Vue) => {
  Vue.component('carousel', Carousel);
  Vue.component('slide', Slide);
};

export default {
  install,
};

export { Carousel, Slide };
